var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fb"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0547 1.19995C6.05953 1.19995 1.19922 6.06026 1.19922 12.0555C1.19922 17.498 5.20836 21.9917 10.4323 22.7768V14.9327H7.74657V12.0791H10.4323V10.1804C10.4323 7.03676 11.9639 5.65663 14.5767 5.65663C15.828 5.65663 16.4897 5.7494 16.803 5.79183V8.28268H15.0208C13.9115 8.28268 13.5242 9.33418 13.5242 10.5194V12.0791H16.7749L16.3338 14.9327H13.5242V22.7999C18.8226 22.081 22.9102 17.5508 22.9102 12.0555C22.9102 6.06026 18.0499 1.19995 12.0547 1.19995Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.1cecb3b0c88d6b798c072db9ac2d4f1e.svg";
export { ForwardRef as ReactComponent };